export default __webpack_public_path__ + "static/sirio-scheda-tecnica-5f19f5ac79e338afb36ae8bf5b9dc79b.pdf";